<template>
    <div>
        <label>Load</label>
        <span :data-value="status1">{{ one }}</span>
        <span :data-value="status5">{{ five }}</span>
        <span :data-value="status15">{{ fifteen }}</span>
    </div>
</template>

<script>
export default {
  computed: {
    one () { return this.$store.getters['Monitoring/load'][0] },
    five () { return this.$store.getters['Monitoring/load'][1] },
    fifteen () { return this.$store.getters['Monitoring/load'][2] },
    status1 () { return this.status(this.one) },
    status5 () { return this.status(this.five) },
    status15 () { return this.status(this.fifteen) }
  },
  methods: {
    status (value) { return value < 1 ? 2 : (value < 2 ? 1 : 0) }
  }
}
</script>

<style scoped>
div{
  display:flex;
  margin-bottom:1px;
  line-height:14px
}
label{
  flex:inherit
}
span{
  margin-left:5px;
  padding:1px 3px;
  color:blue;
  flex:1;
  text-align:center;
  font-weight:bold
}
span[data-value="2"]{
  color:green
}
span[data-value="1"]{
  color:orange
}
span[data-value="0"]{
  color:red
}
</style>
